{
  "home": {
    "heroStop": "STOP HUMAN SAFARI",
    "heroSave": "SAVE KHERSON",
    "heroTitle1": "Humans",
    "heroTitle2": "Are Not Targets",
    "heroDate": "December 13, 14",
    "worldwideRally": "Worldwide Rally",
    "heroHashtags": "#HumansAreNotTargets #StopHumanSafari #SaveKherson",
    "infoText": "Since summer 2024, Russian military use small drones to hunt, kill and terrorise civilians on the streets of Kherson and other frontline cities in Ukraine. <bold>Human safari must stop. YOU can help.</bold> Join thousands around the world to demand this war crime stops.",
    "seeGallery": "See worldwide posters",
    "comingSoon": "Locations coming soon",
    "december": "December",
    "dec": "Dec",
    "october": "October",
    "oct": "Oct",
    "september": "September",
    "sep": "Sep",
    "schedule9": "9th",
    "schedule10": "10th",
    "schedule11": "11th",
    "schedule12": "12th",
    "schedule13": "13th",
    "schedule14": "14th",
    "schedule16": "16th",
    "schedule18": "18th",
    "schedule20": "20th",
    "schedule1": "1st",
    "schedule2": "2nd",
    "schedule3": "3rd",
    "schedule4": "4th",
    "schedule5": "5th",
    "schedule25": "25th",
    "schedule26": "26th",
    "schedule27": "27th",
    "schedule28": "28th",
    "schedule29": "29th",
    "schedule30": "30th",
    "schedule31": "31st",
    "scheduleTBC": "Confirming date...",
    "recommendationsTitle": "Recommendations of the UN Commission",
    "recommendationsRussia": "The Commission recommends that the Russian Federation:",
    "rusRec1": "(a) Immediately end the drone attacks targeting civilians and civilian objects",
    "rusRec2": "(b) Immediately stop all acts that spread terror among the civilian population",
    "rusRec3": "(c) Ensure that all perpetrators involved in drone attacks targeting civilians are held accountable",
    "recommendationsUNStates": "The Commission recommends that other States and regional and international organizations: ",
    "statesRec1": "(a) Contribute both financially and with technical advice to the Government of Ukraine and to civil society organisations, for the provision of comprehensive support for victims and their families;",
    "statesRec2": "(b) For third States whose territory is the destination of persons deported from the occupied territories, undertake necessary efforts together with Ukrainian consular services to support these persons.",
    "reference": "Reference",
    "linkUN": "UN Commission: Russia's \"human safari\" in Ukraine is a crime against humanity",
    "linkGuidelines": "UN Guidelines",
    "linkWiki": "Wikipedia"
  },
  "witnesses": {
    "title": " We are collecting eyewitness accounts!",
    "email": "If you are from Kherson, Nikopol, Zaporizhzhia, Sumy, or the frontline areas of Donbas and have witnessed a “human safari” firsthand, please send us your stories to 📧 <mail>khersonhumansafari@gmail.com</mail>, subject: “human safari.”",
    "type": " If you witnessed the death of a friend or neighbor in a drone attack and wish to share your account, please indicate “eyewitness”; if you were personally attacked, please indicate “survivor.”",
    "requirements": "<b>What we need:</b> city/location, date of attack, short story (3–6 sentences; factual, first-person).",
    "honesty": "Be honest, concise, and avoid including sensitive military positions — you may remain anonymous.",
    "media": "<b>Photos/videos?</b> Write “Photos/videos available”. Do not attach files — we will contact you if visuals are needed.",
    "consent": "<b>Consent for publication:</b> “I agree for this story to be published publicly on the HumanSafari.org website.”"
  },
  "resources": {
    "title": "Key Resources",
    "linkLibraryTitle": "Link Library",
    "linkLibraryDesc": "200 Articles, Reports, Interviews, Firsthand Testimony, and Media Coverage",
    "humanSafariMapTitle": "Tochnyi Human Safari map",
    "humanSafariMapDesc": "An interactive map of Human Safari attacks in Kherson, compiled from open-source reports by local authorities and from attack footage geolocated by the Tochnyi team.",
    "truthHoundsTitle": "Truth Hounds Report",
    "truthHoundsDesc": "Killzone: How Russian Drones Are Devastating the River Dnipro’s Right Bank",
    "hrwTitle": "Human Rights Watch Report on Drone Attacks in Kherson",
    "hrwDesc": "HRW Report",
    "unReportsTitle": "UN Human Rights Council Reports",
    "report1": "UN Report #1",
    "report3": "UN Report #3",
    "guidelines": "UN Guidelines",
    "wikipediaTitle": "Wikipedia",
    "english": "English",
    "french": "French",
    "documentaryTitle": "Documentary",
    "documentaryDesc": "www.khersonhumansafari.com"
  },
  "navbar": {
    "main": "13th-14th Dec",
    "eyewitnesses": "accounts",
    "rallies": "photos",
    "help": "deoccupied Kherson",
    "leftBank": "occupied Kherson",
    "action": "Dec '25",
    "oleshky": "global demo - Oleshky",
    "menu": "Menu"
  },
  "leftBank": {
    "pageTitle": "Drone Siege",
    "para1": "An acute humanitarian emergency affects 6,000 civilians trapped under a drone siege in occupied Oleshky, Hola Prystan, Stara Zburivka, and Nova Zburivka - occupied Kherson region. In Oleshky 1,200 - 2,000. The occupying authority is obligated to support them - instead they are used as human shields by the russian forces, to hide behind this population while carrying out Human Safari attacks on the opposite bank. Systematic obstruction of evacuation and humanitarian access is reported by Ukrainian authorities and humanitarian actors.",
    "para2": "Civilians lack food, water, medical care, medicines, electricity, gas, and communications. Roads are heavily mined and drone activity restricts movement. No vehicles have been able to enter or leave since 26 May. Fuel and food supplies are nearly exhausted.",
    "meidasTitle": "Meidas Touch / Valor Media Network",
    "meidasVideo": "Video: Kherson and Oleshky: Witnessing Genocide (12 min watch)",
    "meidasArticle": "Article: The Kherson Region: How Russia Uses Civilians as a Tool of War (5 min read)",
    "kyivPostTitle": "Kyiv Post",
    "kyivPostArticle": "Article: Global Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate (7 min read)",
    "tellPost": "and tell others about the Drone Siege",
    "callToHelp": "YOU can help. Here's how",
    "donateIntro": "These are initiatives which provide high-impact and targeted help directly to people who have fled from or, where it's possible, are trapped in Oleshky.",
    "signTitle": "Sign",
    "signSub": "petitions",
    "petitionBy": "by {{name}}",
    "petitions": {
      "euParliament": "European Parliament – Petition No 1439/2026 on establishing a humanitarian evacuation corridor for civilians trapped under siege in Russian-occupied Oleshky, Ukraine",
      "ukParliament": "UK Parliament – Seek to introduce a UK-led humanitarian aid corridor to Oleshky in Ukraine"
    },
    "publicActionLead": "Point the spotlight on the Drone Siege where you are.",
    "organiseAction": "Organise an action.",
    "policyBody": "The Ukrainian authorities are in consultations with the International Committee of the Red Cross on establishing a humanitarian evacuation corridor from occupied settlements in the Kherson region and securing humanitarian access for food, water, medicine, fuel, and medical assistance. As of early June, no functioning evacuation corridor or sustained humanitarian access mechanism is in place.",
    "documentaryTitle": "Oleshky, short documentary",
    "downloadTitle": "Download",
    "downloadSub": "graphics"
  },
  "footer": {
    "addCityText": "To add your city, send an email to: ",
    "organiseText": "Add your demo - get in touch:",
    "contact": "Contact:"
  },
  "byCountry": "view by country",
  "byDate": "view by date",
  "countries": {
    "australia": "Australia",
    "austria": "Austria",
    "bulgaria": "Bulgaria",
    "canada": "Canada",
    "czechia": "Czechia",
    "denmark": "Denmark",
    "estonia": "Estonia",
    "finland": "Finland",
    "france": "France",
    "georgia": "Georgia",
    "germany": "Germany",
    "hungary": "Hungary",
    "italy": "Italy",
    "japan": "Japan",
    "mexico": "Mexico",
    "netherlands": "Netherlands",
    "norway": "Norway",
    "poland": "Poland",
    "romania": "Romania",
    "spain": "Spain",
    "sweden": "Sweden",
    "southAfrica": "South Africa",
    "ukraine": "Ukraine",
    "unitedKingdom": "United Kingdom",
    "usa": "USA",
    "ireland": "Ireland",
    "belgium": "Belgium"
  },
  "cities": {
    "alicante": {
      "city": "Alicante",
      "country": "Spain",
      "time": "Alicante - Spain, 16:00 - 17:00",
      "location": "Auditorio la Concha, Explanada de España",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule13"
    },
    "barcelona": {
      "city": "Barcelona",
      "country": "Spain",
      "time": "Barcelona - Spain, 12:00 - 14:00",
      "location": "Placa de Sant Jaume",
      "cleanTime": "12:00 - 14:00",
      "day": "schedule14"
    },
    "berkeley": {
      "city": "Berkeley",
      "country": "USA",
      "time": "Berkeley - USA, 12:00 - 13:00",
      "location": "4th St.",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "berlin": {
      "city": "Berlin",
      "country": "Germany",
      "time": "Berlin - Germany, 12:00",
      "location": "Tempelhofer Feld, entry Leinstr./corner of Oderstr.",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "bettendorf": {
      "city": "Bettendorf",
      "country": "USA",
      "time": "Bettendorf - USA, 17:30 - Film Screening",
      "location": "Bettendorf Public Library",
      "cleanTime": "17:30 - Film Screening",
      "day": "schedule11"
    },
    "birmingham": {
      "city": "Birmingham",
      "country": "United Kingdom",
      "time": "Birmingham - United Kingdom, 14:00 - 15:30",
      "location": "Baskerville House, Cambridge St.",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "bonn": {
      "city": "Bonn",
      "country": "Germany",
      "time": "Bonn - Germany, 14:00 - 16:00",
      "location": "Poststraße, in front of the Hauptbahnhof",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "bremen": {
      "city": "Bremen",
      "country": "Germany",
      "time": "Bremen - Germany, 15:00 - 18:00",
      "location": "Bahnhofsvorplatz",
      "cleanTime": "15:00 - 18:00",
      "day": "schedule14"
    },
    "budapest": {
      "city": "Budapest",
      "country": "Hungary",
      "time": "Budapest - Hungary, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "chicago": {
      "city": "Chicago",
      "country": "USA",
      "time": "Chicago - USA, 13:00 - 15:00",
      "location": "410 N. Michigan ave. (Wrigley building)",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "constanta": {
      "city": "Constanța",
      "country": "Romania",
      "time": "Constanța - Romania, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "copenhagen": {
      "city": "Copenhagen",
      "country": "Denmark",
      "time": "Copenhagen - Denmark, 14:00",
      "location": "Axeltorv",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "dallas": {
      "city": "Dallas",
      "country": "USA",
      "time": "Dallas - USA, 12:00 - 13:00",
      "location": "Dallas City Hall Plaza",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "denver": {
      "city": "Denver",
      "country": "USA",
      "time": "Denver - USA, 12:00",
      "location": "Colorado Capitol Building, West Steps",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "edinburgh": {
      "city": "Edinburgh",
      "country": "United Kingdom",
      "time": "Edinburgh - United Kingdom, 13:00 - 15:00",
      "location": "Duke of Wellington Monument",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule13"
    },
    "fortWorth": {
      "city": "Fort Worth",
      "country": "USA",
      "time": "Fort Worth - USA, 14:00 - 15:00",
      "location": "Tarrant County Courthouse",
      "cleanTime": "14:00 - 15:00",
      "day": "schedule14"
    },
    "hamburg": {
      "city": "Hamburg",
      "country": "Germany",
      "time": "Hamburg - Germany, 14:00 - 16:00",
      "location": "Mönckebergbrunnen (Mönckebergstraße)",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule20"
    },
    "houghton": {
      "city": "Houghton, Michigan",
      "country": "USA",
      "time": "Houghton, Michigan - USA, 15:00",
      "location": "Portage Lake Lift Bridge",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "helsinki": {
      "city": "Helsinki",
      "country": "Finland",
      "time": "Helsinki - Finland, 17:00 - 18:00",
      "location": "Narinkkatori",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule16"
    },
    "izumo14": {
      "city": "Izumo",
      "country": "Japan",
      "time": "Izumo - Japan, 13:00",
      "location": "Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "13:00",
      "day": "schedule14"
    },
    "izumo20": {
      "city": "Izumo",
      "country": "Japan",
      "time": "Izumo - Japan",
      "location": "Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "",
      "day": "schedule20"
    },
    "kamloops": {
      "city": "Kamloops, BC",
      "country": "Canada",
      "time": "Kamloops, BC - Canada, 15:00 - 16:00",
      "location": "City Hall",
      "cleanTime": "15:00 - 16:00",
      "day": "schedule13"
    },
    "kyiv": {
      "city": "Kyiv",
      "country": "Ukraine",
      "time": "Kyiv - Ukraine, 17:00-18:00",
      "location": "Maidan Nezalezhnosti",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule14"
    },
    "leipzig": {
      "city": "Leipzig",
      "country": "Germany",
      "time": "Leipzig - Germany, 12:00 - 13:00",
      "location": "Willy Brandt Platz",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "london": {
      "city": "London",
      "country": "United Kingdom",
      "time": "London - United Kingdom, 18:30 - Film Screening",
      "location": "Ukrainian House, 154 Holland Park Avenue",
      "cleanTime": "18:30 - Film Screening",
      "day": "schedule12"
    },
    "losAngeles": {
      "city": "Los Angeles",
      "country": "USA",
      "time": "Los Angeles - USA, 15:30",
      "location": "4051 Melrose Ave",
      "cleanTime": "15:30",
      "day": "schedule14"
    },
    "malaga": {
      "city": "Málaga",
      "country": "Spain",
      "time": "Málaga - Spain, 18:00 - Film Screening",
      "location": "Maydan - Centro Historico Cultural Ukraniano",
      "cleanTime": "18:00 - Film Screening",
      "day": "schedule13"
    },
    "manchester": {
      "city": "Manchester",
      "country": "United Kingdom",
      "time": "Manchester - United Kingdom, 14:00 - 15:30",
      "location": "St Peter's Square Emmeline Pankhurst Memorial",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "mexicoCity": {
      "city": "Mexico City",
      "country": "Mexico",
      "time": "Mexico City - Mexico, 11:00",
      "location": "Alameda Central. \"Americas\" fountain (between Hemiciclo Juárez and Kiosk)",
      "cleanTime": "11:00",
      "day": "schedule14"
    },
    "milan": {
      "city": "Milan",
      "country": "Italy",
      "time": "Milan - Italy, 15:00",
      "location": "The Duomo di Milano",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "munich": {
      "city": "Munich",
      "country": "Germany",
      "time": "Munich - Germany, 17:00 - 19:00",
      "location": "Odeonsplatz",
      "cleanTime": "17:00 - 19:00",
      "day": "schedule14"
    },
    "newYork13": {
      "city": "New York",
      "country": "USA",
      "time": "New York - USA, 16:00",
      "location": "Times Square",
      "cleanTime": "16:00",
      "day": "schedule13"
    },
    "newYork14": {
      "city": "New York",
      "country": "USA",
      "time": "New York - USA, 13:00 - 14:00",
      "location": "Times Square",
      "cleanTime": "13:00 - 14:00",
      "day": "schedule14"
    },
    "nienburg": {
      "city": "Nienburg (Weser)",
      "country": "Germany",
      "time": "Nienburg (Weser) - Germany, 17:00",
      "location": "Stettiner Str.2A",
      "cleanTime": "17:00",
      "day": "schedule13"
    },
    "oslo": {
      "city": "Oslo",
      "country": "Norway",
      "time": "Oslo - Norway, 12:00 - 13:00",
      "location": "Eidsvoll Plass, Stortinget",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule14"
    },
    "ostersund": {
      "city": "Östersund",
      "country": "Sweden",
      "time": "Östersund - Sweden, 11:00 - 14:00",
      "location": "Stortorget (Main Square)",
      "cleanTime": "11:00 - 14:00",
      "day": "schedule13"
    },
    "ottawa12": {
      "city": "Ottawa",
      "country": "Canada",
      "time": "Ottawa - Canada, 12:30 - 13:30",
      "location": "russian Embassy",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule12"
    },
    "ottawa13": {
      "city": "Ottawa",
      "country": "Canada",
      "time": "Ottawa - Canada, 12:00",
      "location": "US Embassy",
      "cleanTime": "12:00",
      "day": "schedule13"
    },
    "paris": {
      "city": "Paris",
      "country": "France",
      "time": "Paris - France, 15:30",
      "location": "Square Taras Chevchenko -> Fontaine Saint-Michel (march)",
      "cleanTime": "15:30",
      "day": "schedule13"
    },
    "plovdiv": {
      "city": "Plovdiv",
      "country": "Bulgaria",
      "time": "Plovdiv - Bulgaria, 16:00 - 17:00",
      "location": "by the Levski House",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule14"
    },
    "prague": {
      "city": "Prague",
      "country": "Czechia",
      "time": "Prague - Czechia, 14:00",
      "location": "Palackého Square",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "rosendal": {
      "city": "Rosendal",
      "country": "South Africa",
      "time": "Rosendal - South Africa, 11:00",
      "location": "South African Police Service offices",
      "cleanTime": "11:00",
      "day": "schedule13"
    },
    "sanAndres": {
      "city": "San Andrés, Tenerife",
      "country": "Spain",
      "time": "San Andrés, Tenerife - Spain, 13:00",
      "location": "--",
      "cleanTime": "13:00",
      "day": "schedule13"
    },
    "sanDiego": {
      "city": "San Diego",
      "country": "USA",
      "time": "San Diego - USA, 14:00 - 16:00",
      "location": "El Cid Statue, Balboa Park",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "sanFrancisco": {
      "city": "San Francisco",
      "country": "USA",
      "time": "San Francisco - USA, 14:00",
      "location": "Ferry Plaza, Embarcadero",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "schwerin": {
      "city": "Schwerin",
      "country": "Germany",
      "time": "Schwerin - Germany, 19:00 - Film Screening",
      "location": "Internationales Haus, Ziegenmarkt 4",
      "cleanTime": "19:00 - Film Screening",
      "day": "schedule13"
    },
    "seattle": {
      "city": "Seattle",
      "country": "USA",
      "time": "Seattle - USA, 12:30 - 15:30",
      "location": "1005 E Union St.",
      "cleanTime": "12:30 - 15:30",
      "day": "schedule13"
    },
    "svetiVlas": {
      "city": "Sveti Vlas",
      "country": "Bulgaria",
      "time": "Sveti Vlas - Bulgaria, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "sydney": {
      "city": "Sydney",
      "country": "Australia",
      "time": "Sydney - Australia, 14:00",
      "location": "Sydney Town Hall",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "tallinn": {
      "city": "Tallinn",
      "country": "Estonia",
      "time": "Tallinn - Estonia, 15:00 - Film Screening and Rally",
      "location": "Sõprus Cinema, Vana-Posti tn.8",
      "cleanTime": "15:00 - Film Screening and Rally",
      "day": "schedule13"
    },
    "tarragona": {
      "city": "Tarragona",
      "country": "Spain",
      "time": "Tarragona - Spain, 18:30",
      "location": "Balcó Mediterrani",
      "cleanTime": "18:30",
      "day": "schedule14"
    },
    "theHague": {
      "city": "The Hague",
      "country": "Netherlands",
      "time": "The Hague - Netherlands, 13:00 - 15:00",
      "location": "In front of the Peace Palace / ICC",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "tbilisi": {
      "city": "Tbilisi",
      "country": "Georgia",
      "time": "Tbilisi - Georgia, 21:00",
      "location": "Tbilisi",
      "cleanTime": "21:00",
      "day": "schedule14"
    },
    "tranas": {
      "city": "Tranås",
      "country": "Sweden",
      "time": "Tranås - Sweden, 11:00 - 13:00, 13:00",
      "location": "Storgatan 49 (Kultivera)",
      "cleanTime": "11:00 - 13:00, 13:00",
      "day": "schedule13"
    },
    "vienna": {
      "city": "Vienna",
      "country": "Austria",
      "time": "Vienna - Austria, 16:00 - 18:00",
      "location": "Stock im Eisen Platz (next to Stephansdom)",
      "cleanTime": "16:00 - 18:00",
      "day": "schedule14"
    },
    "washingtonDC": {
      "city": "Washington, D.C.",
      "country": "USA",
      "time": "Washington, D.C. - USA, 12:30 - 13:30",
      "location": "The White House",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule14"
    },
    "wroclaw": {
      "city": "Wrocław",
      "country": "Poland",
      "time": "Wrocław - Poland, 13:00",
      "location": "Freedom Square (direction People's Forum of Music)",
      "cleanTime": "13:00",
      "day": "schedule14"
    }
  },
  "help": {
    "organise": "To get in touch:",
    "email": "khersonhumansafari@gmail.com",
    "actionEmail": "antihumansafari@gmail.com",
    "share": "Share on {{platform}}",
    "website": "Website",
    "facebook": "Facebook",
    "x": "X",
    "youtube": "YouTube",
    "bluesky": "Bluesky",
    "donate": "Donate",
    "donateIntro": "These are initiatives which provide high-impact and targeted help directly to protect Kherson civilians from Human Safari.",
    "shareTitle": "Spread the word",
    "filmScreening": "Organise a screening of documentary film Kherson Human Safari:",
    "howItStarted": "How it started",
    "khs": {
      "name": "Kherson Human Safari",
      "desc": "Zarina Zabrisky, journalist and filmmaker, led the worldwide rally and directed the documentary film Kherson Human Safari."
    },
    "fellas": {
      "name": "Fellas4Europe",
      "desc": "Civilian protection for Kherson streets — protecting civilians from drone attacks.",
      "foodDesc": "Food relief.",
      "foodNote": "When you donate, write “Food for Cherson” as the reference."
    },
    "ahs": {
      "name": "Anti Human Safari Project",
      "desc": "Drone detectors and protective vests for volunteers and emergency services in Kherson."
    },
    "pageTitle": "Stop Human Safari",
    "sectionIntro": "Since summer 2024, Russian military use small drones to hunt, kill and terrorise civilians on the streets of Kherson and other frontline cities in Ukraine.",
    "sectionIntro2": "A systematic and deliberate murder campaign, the Russian drone operators post the footage of their victims openly in Telegram channels to brag. The UN recognised Human Safari as an ongoing war crime in May 2025.",
    "sectionIntro3": "Too little is being done. Human Safari must stop.",
    "sectionIntroBold": "YOU can help. Here's how",
    "step2Title": "Organise",
    "step3Title": "Tell people",
    "step3Para": "Use the hashtags",
    "step3ParaPost": "and tell others about Human Safari",
    "instagram": "Instagram",
    "step2Bullet1": "a film screening",
    "step2Bullet2": "a public action",
    "step2Bullet3": "news coverage",
    "publicActionLead": "Point the spotlight on Human Safari where you are.",
    "reachOutPre": "You can",
    "reachOut": "reach out",
    "reachOutPost": "for ideas and resources",
    "newsCoverageLead": "via your media contacts. Tell them about Human Safari and the risk to all future and current areas of conflict.",
    "putInTouchPre": "You can also",
    "putInTouch": "put us directly in touch",
    "inform": "Inform",
    "informSub": "yourself and others",
    "policyTitle": "Policy",
    "policyBody": "The proposed LORA Act (Liability for Operators and Responsible Authorities Act) would establish sanctions across the full chain of responsibility — from Russian FPV operators and commanders to senior military leadership, as well as manufacturers and suppliers enabling drone production and deployment against civilians.",
    "policyHelp": "You can help on a policy level?",
    "getInTouch": "Get in touch",
    "disdict": {
      "title": "Disinformation Dictionary",
      "link": "Human Safari"
    },
    "kryla": {
      "name": "Kryla Foundation",
      "desc": "Support them to pay for accommodation and basic supplies for Oleshky residents."
    }
  },
  "action": {
    "intro": "We started with a worldwide demonstration. Now you can:",
    "helpLink": "help here"
  },
  "accounts": {
    "heading": "Accounts"
  },
  "media": {
    "close": "Close",
    "view": "View media",
    "previous": "Previous",
    "next": "Next",
    "andrushenkoCredit": "Oleksandr Andrushenko, photo correspondent for the outlet Vgoru",
    "khersonPoliceCredit": "from @khersonpolice",
    "antypenkoCredit": "Ivan Antypenko, photojournalist from Kherson",
    "telegramChannelCredit": "posted by the Russian Human Safari Telegram channel “from Mariupol to the Carpathians”",
    "fruitSellerDescription": "Fruit seller chased by fibre-optic drone",
    "burntCarDescription": "Burnt-out car in Kherson",
    "bridgeAttackDescription": "Teenage boy murdered by an FPV drone under a bridge in Kherson",
    "busAttackDescription": "One of many FPV drone attacks on public transport",
    "fpvDroneDescription": "FPV drone out on Human Safari",
    "antiDroneNetsDescription": "Kherson street covered by nets against Human Safari drones",
    "firefighterDescription": "Firefighter extinguishes a car after a Human Safari strike, victim lies behind"
  },
  "follow": {
    "title": "Follow",
    "subHumanSafari": "quality sources reporting from Kherson and about Human Safari",
    "subDroneSiege": "quality sources reporting from Kherson and about the Drone Siege",
    "localPress": "local Ukrainian-language press",
    "lang": {
      "english": "English",
      "german": "German",
      "ukrainian": "Ukrainian"
    },
    "language": "Language: {{list}}",
    "languages": "Languages: {{list}}",
    "langSeparator": ", ",
    "zabrisky": {
      "name": "Zarina Zabrisky",
      "desc": "US journalist and filmmaker based in Kherson, reporting for Byline Times and Euromaidan Press; director of the documentary Kherson Human Safari."
    },
    "naber": {
      "name": "Ibrahim Naber",
      "desc": "Chief reporter for the German newspaper Die Welt; reports periodically on Human Safari in Kherson."
    },
    "kelley": {
      "name": "Brendan Kelley",
      "desc": "Writes Kherson Weekly, a running record of Russian drone attacks on civilians in Kherson and the surrounding villages."
    },
    "vgoru": {
      "name": "Vgoru",
      "desc": "Independent media platform from Kherson region, reporting on life under attack and in occupation."
    },
    "suspilne": {
      "name": "Suspilne Kherson",
      "desc": "The Kherson newsroom of Ukraine's public broadcaster."
    },
    "most": {
      "name": "MOST",
      "desc": "Local Kherson news agency covering the city and the region."
    }
  },
  "rallies": {
    "oleshky2026": {
      "heroStop": "STOP DRONE SIEGE",
      "heroSave": "SAVE OLESHKY",
      "worldwideRally": "Worldwide Demo",
      "heroDate": "October",
      "infoText1": "Thousands of civilians are trapped under drone siege in Oleshky, Hola Prystan, Stara Zburivka and Nova Zburivka. They are used as human shields by Russian forces hiding behind them to carry out Human Safari drone attacks on the opposite bank.",
      "infoText2": "The crisis is acute - lack of food, water, medical care, medicines, electricity, gas, and communications. Roads are heavily mined and drone activity restricts movement. <bold>YOU can help. Join thousands around the world to demand the drone siege stops.</bold>",
      "imageAlt": "A starving dog among human bones in ruined Oleshky, under a red sky full of drones, with the words Stop Russian Drone Siege",
      "demandsTitle": "We call for:",
      "demand1": "safe and effective humanitarian corridors to Oleshky and other affected communities.",
      "demand2": "immediate humanitarian relief and assistance for victims of human safari attacks.",
      "demand3": "appropriate sanctions against individuals and supply chains responsible for attacks targeting civilians.",
      "demand4": "steps to deter the use of small drones to systematically target and terrorise civilians in Kherson, Ukraine, and elsewhere.",
      "cities": {
        "edinburgh": {
          "city": "Edinburgh",
          "country": "United Kingdom",
          "time": "Edinburgh - United Kingdom, 14:00",
          "location": "Duke of Wellington Monument",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "birmingham": {
          "city": "Birmingham",
          "country": "United Kingdom",
          "time": "Birmingham - United Kingdom, 14:00 - 16:00",
          "location": "Opposite the Hall of Memory, B1 2ND",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "vienna": {
          "city": "Vienna",
          "country": "Austria",
          "time": "Vienna - Austria, 15:00 - 17:00",
          "location": "Stephansplatz, 1010 Wien",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule27"
        },
        "munich": {
          "city": "Munich",
          "country": "Germany",
          "time": "Munich - Germany, 15:00 - 17:00",
          "location": "Marienplatz, 80331 München",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule3"
        },
        "london": {
          "city": "London",
          "country": "United Kingdom",
          "time": "London - United Kingdom, 16:00 - 18:00",
          "location": "Downing Street",
          "cleanTime": "16:00 - 18:00",
          "day": "schedule27"
        },
        "manchester": {
          "city": "Manchester",
          "country": "United Kingdom",
          "time": "Manchester - United Kingdom, 14:00 - 15:30",
          "location": "St Peter's Square",
          "cleanTime": "14:00 - 15:30",
          "day": "schedule26"
        },
        "sydney": {
          "city": "Sydney",
          "country": "Australia",
          "time": "Sydney - Australia, 14:00",
          "location": "Sydney Town Hall",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "paris": {
          "city": "Paris",
          "country": "France",
          "time": "Paris - France, 15:30 - 18:30",
          "location": "From Saint Volodymyr church to Place Saint-Michel",
          "cleanTime": "15:30 - 18:30",
          "day": "schedule26"
        },
        "parisSep30": {
          "city": "Paris",
          "country": "France",
          "time": "Paris - France, 18:00",
          "location": "Rambuteau metro",
          "cleanTime": "18:00",
          "day": "schedule30"
        },
        "lyon": {
          "city": "Lyon",
          "country": "France",
          "time": "Lyon - France, 14:00",
          "location": "Place de la Comédie",
          "cleanTime": "14:00",
          "day": "schedule27"
        },
        "dublin": {
          "city": "Dublin",
          "country": "Ireland",
          "time": "Dublin - Ireland, 13:00",
          "location": "The GPO",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "brussels": {
          "city": "Brussels",
          "country": "Belgium",
          "time": "Brussels - Belgium, 10:00 - 11:00",
          "location": "La Petite rue de la Loi, 1040 Brussels (Schuman Roundabout)",
          "cleanTime": "10:00 - 11:00",
          "day": "schedule28"
        },
        "ottawa": {
          "city": "Ottawa",
          "country": "Canada",
          "time": "Ottawa - Canada, 12:30 - 13:30",
          "location": "Russian Embassy, 285 Charlotte St",
          "cleanTime": "12:30 - 13:30",
          "day": "schedule2"
        },
        "nantes": {
          "city": "Nantes",
          "country": "France",
          "time": "Nantes - France, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule3"
        },
        "gdansk": {
          "city": "Gdańsk",
          "country": "Poland",
          "time": "Gdańsk - Poland, 18:30 - 19:30",
          "location": "Długi Targ, next to the Neptune Fountain",
          "cleanTime": "18:30 - 19:30",
          "day": "schedule27"
        },
        "chicago": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley building)",
          "cleanTime": "13:00",
          "day": "schedule27"
        },
        "chicagoOct4": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley building)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "chicagoOct11": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley building)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "chicagoOct18": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley building)",
          "cleanTime": "13:00",
          "day": "schedule18"
        },
        "dresden": {
          "city": "Dresden",
          "country": "Germany",
          "time": "Dresden - Germany, 14:00",
          "location": "Neumarkt",
          "cleanTime": "14:00",
          "day": "schedule4"
        },
        "malaga": {
          "city": "Málaga",
          "country": "Spain",
          "time": "Málaga - Spain, 19:00",
          "location": "Plaza de la Marina",
          "cleanTime": "19:00",
          "day": "schedule3"
        },
        "londonSep29": {
          "city": "London",
          "country": "United Kingdom",
          "time": "London - United Kingdom, 18:00",
          "location": "Trafalgar Square",
          "cleanTime": "18:00",
          "day": "schedule29"
        },
        "plovdiv": {
          "city": "Plovdiv",
          "country": "Bulgaria",
          "time": "Plovdiv - Bulgaria, 17:00",
          "location": "Main street (Glavnata), by the Kamenitza steps / the \"Together\" sign",
          "cleanTime": "17:00",
          "day": "schedule3"
        },
        "budapest": {
          "city": "Budapest",
          "country": "Hungary",
          "time": "Budapest - Hungary, 17:00 - 20:00",
          "location": "Szent István tér (St Stephen's Square)",
          "cleanTime": "17:00 - 20:00",
          "day": "schedule30"
        },
        "londonOct1": {
          "city": "London",
          "country": "United Kingdom",
          "time": "London - United Kingdom, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule1"
        },
        "londonOct3": {
          "city": "London",
          "country": "United Kingdom",
          "time": "London - United Kingdom, 12:00",
          "location": "Trafalgar Square",
          "cleanTime": "12:00",
          "day": "schedule3"
        },
        "hamburg": {
          "city": "Hamburg",
          "country": "Germany",
          "time": "Hamburg - Germany, 14:00 - 16:00",
          "location": "Landungsbrücken, Jan-Fedder-Promenade, by Pier 1, 20359 Hamburg",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "kiel": {
          "city": "Kiel",
          "country": "Germany",
          "time": "Kiel - Germany, 15:00 - 16:00",
          "location": "Holstenstraße",
          "cleanTime": "15:00 - 16:00",
          "day": "schedule4"
        },
        "oslo": {
          "city": "Oslo",
          "country": "Norway",
          "time": "Oslo - Norway",
          "location": "Eidsvolls plass",
          "cleanTime": "",
          "day": "schedule3"
        },
        "leipzig": {
          "city": "Leipzig",
          "country": "Germany",
          "time": "Leipzig - Germany, 17:00 - 18:00",
          "location": "Main station (Willy-Brandt-Platz)",
          "cleanTime": "17:00 - 18:00",
          "day": "schedule5"
        },
        "londonOct9": {
          "city": "London",
          "country": "United Kingdom",
          "time": "London - United Kingdom, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule9"
        },
        "londonOct10": {
          "city": "London",
          "country": "United Kingdom",
          "time": "London - United Kingdom, 13:00",
          "location": "Trafalgar Square",
          "cleanTime": "13:00",
          "day": "schedule10"
        },
        "dublinOct11": {
          "city": "Dublin",
          "country": "Ireland",
          "time": "Dublin - Ireland, 13:00",
          "location": "The GPO",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "dublinOct25": {
          "city": "Dublin",
          "country": "Ireland",
          "time": "Dublin - Ireland, 14:00",
          "location": "The GPO",
          "cleanTime": "14:00",
          "day": "schedule25"
        },
        "nantesOct31": {
          "city": "Nantes",
          "country": "France",
          "time": "Nantes - France, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule31"
        }
      },
      "posterStopSiege": "Stop Russian Drone Siege",
      "posterNoRoadOut": "The roads in and out of Oleshky are blocked",
      "posterHumanitarianCatastrophe": "Oleshky. A humanitarian catastrophe under occupation",
      "seeGallery": "See / download posters"
    },
    "artBy": "Art: {{name}}",
    "downloadPoster": "Download poster",
    "reel": {
      "download": "Download video (MP4)"
    },
    "addDemo": {
      "title": "add your demo",
      "where": "where: town/city",
      "contact": "email/number",
      "message": "message: who you represent, your demo is confirmed or WIP, link to online announcement, any other details",
      "submit": "Submit",
      "sending": "Sending…",
      "thanks": "Thank you! We'll be in touch.",
      "error": "Something went wrong. Please try again.",
      "contactInvalid": "Please enter a valid email, or a phone number with country code (e.g. +44 7700 900123).",
      "date": "date",
      "time": "start time (local)",
      "whereInvalid": "Please enter a town or city name, e.g. Paris or Kyiv, Ukraine.",
      "datePlaceholder": "date: dd/mm"
    }
  },
  "seo": {
    "oleshky": {
      "title": "Stop Drone Siege — Save Oleshky | Worldwide Demos",
      "description": "Russian drones besiege thousands of civilians in occupied Oleshky, Ukraine, cut off from food, water and medicine. Find a demo near you and demand safe passage."
    },
    "leftBank": {
      "title": "Drone Siege of Oleshky and Occupied Kherson Region",
      "description": "Thousands of civilians are trapped under a Russian drone siege in occupied Oleshky, Hola Prystan and nearby villages. Learn what is happening and how you can help."
    },
    "help": {
      "title": "Stop Human Safari — Russian Drones Hunting Civilians in Kherson",
      "description": "Russian drones hunt civilians in Kherson, Ukraine. Learn about the Human Safari war crime and how you can help stop it."
    },
    "action": {
      "title": "December 2025 Worldwide Rally — Stop Human Safari, Save Kherson",
      "description": "Photos, posters and places from the December 2025 worldwide rally against Russian drone attacks on civilians in Kherson, Ukraine."
    },
    "rallies": {
      "title": "Rally Photos — Stop Human Safari",
      "description": "Photos from rallies around the world against Russian drone attacks on civilians in Kherson, Ukraine."
    },
    "resources": {
      "title": "Human Safari Resources — Reports, Articles and Testimony",
      "description": "Reports, articles, interviews and eyewitness testimony on Russian drone attacks on civilians in Kherson, Ukraine."
    },
    "reel": {
      "title": "Save Oleshky — Demo Video",
      "description": "Video of the worldwide Save Oleshky demos, October 2026."
    }
  }
}
